exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demand{\n  overflow: auto;\n  margin-bottom: 2em;\n}\n.demand-recap{\n  width: 25%;\n  float: left;\n  text-align: center;\n}\n\n.ui.modal{\n  top: 50% !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/transport-history/transport-history.component.css
// module id = ../../../../../src/app/_components/transport-history/transport-history.component.css
// module chunks = main